// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'a7cf9f39792cd1419123cb8b266ca4e8f226f2a3';
export const BUILD_NUMBER = '188';
export const BUILD_TIMESTAMP = '2026-07-06T02:24:09.749Z';
